<template>
  <div>
    <b-card :title="$t('pharmacy.Add Patient Drug')">
      <b-card-text>
        <b-row>
          <b-col lg="4">
            <CategoryModal isPharmacy="true" @category="assignCategory" />
          </b-col>
          <b-col v-if="sciFilter" lg="4">
            <AutoComplete
              :label="$t('pharmacy.drugs')"
              :placeholder="$t('pharmacy.drugs')"
              v-model="drugForm.item_id"
              param-query="search"
              :serializer="(val) => val"
              endpoint="item"
              text-title="name"
              :otherQuery="`filter[category_id]=${sciFilter}&filter[type]=pharmacy`"
            />
          </b-col>

          <b-col lg="4">
            <b-form-group :label="$t('pharmacy.Dose')" label-for="Dose">
              <b-form-input
                id="Dose"
                v-model="drugForm.dose"
                :placeholder="$t('pharmacy.Dose')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <b-form-group :label="$t('pharmacy.status')">
              <v-select
                v-model="drugForm.status"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusList"
                label="text"
                :reduce="(status) => status.value"
                :placeholder="$t('pharmacy.status')"
              />
            </b-form-group>
          </b-col>

          <b-col lg="4">
            <b-form-group :label="$t('pharmacy.Quantity')" label-for="Quantity">
              <b-form-input
                type="number"
                id="Quantity"
                v-model="drugForm.quantity"
                :placeholder="$t('pharmacy.Quantity')"
              />
            </b-form-group>
          </b-col>
          <b-col lg="4">
            <!-- <b-form-group :label="$t('common.price')" label-for="Price">
              <b-form-input
                type="number"
                id="Price"
                v-model="drugForm.price"
                :placeholder="$t('common.price')"
              />
            </b-form-group> -->
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end">
          <b-button
            class="mt-2"
            ref="myButton"
            variant="primary"
            @click="addToDrugsList"
          >
            {{ $t("pharmacy.Add to Drugs List") }}
          </b-button>
        </div>
      </b-card-text>
    </b-card>
    <b-card :title="$t('pharmacy.drugs')">
      <b-table
        :items="drugs"
        responsive
        :fields="tableColumns"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
      >
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
      <div class="d-flex justify-content-end">
        <b-button
          :disabled="drugs.length === 0"
          class="mt-2"
          ref="myButton"
          variant="primary"
          @click="submitItem"
        >
          {{ $t("common.submit") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BCardText,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import vSelect from "vue-select";
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");

export default {
  components: {
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    CategoryModal,
    BCardText,
    vSelect,
  },
  data() {
    return {
      sciFilter: null,
      categoryFilter: {
        name: "",
        id: "",
      },
      statusList: [
        {
          text: "Pending",
          value: "0",
        },
        {
          text: "External",
          value: "3",
        },
      ],
      loading: true,
      drugForm: {
        item_id: "",
        patient_card_id: this.$route.params.patient_card_id,
        quantity: "",
        dose: "",
        // price: '',
        status: "",
      },

      tableColumns: [
        { key: "item_id.name", label: this.$t("common.name"), sortable: true },

        {
          key: "quantity",
          label: this.$t("pharmacy.Quantity"),
          sortable: true,
        },
        { key: "dose", label: this.$t("pharmacy.Dose"), sortable: true },
        { key: "status", label: this.$t("pharmacy.status"), sortable: true },
        // { key: 'price', label: this.$t('common.price'), sortable: true },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      drugs: [],
      params: {
        form: {},
        path: "",
      },
    };
  },

  methods: {
    addToDrugsList() {
      console.log(this.drugForm.item_id);
      if (!this.drugForm.item_id) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Please select a drug",
            variant: "danger",
          },
        });
        return;
      }
      this.drugs.push(this.drugForm);
      this.sciFilter = null;
      this.drugForm = {
        item_id: "",
        patient_card_id: this.$route.params.patient_card_id,
        quantity: "",
        dose: "",
        // price: '',
        status: "",
      };
    },
    removeItem(item) {
      this.drugs = this.drugs.filter((drug) => drug !== item);
    },

    assignCategory(v) {
      this.drugForm.item_id = null;
      this.sciFilter = v.id;
    },

    submitItem() {
      this.drugs = this.drugs.map((drug) => ({
        ...drug,
        item_id: drug.item_id.id,
      }));

      (this.params.form = { drugs: this.drugs }),
        (this.params.path = `/patientCardDrug`),
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.$router.go(-1);

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Created",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
